import { MAPBOX_TOKEN } from '../config/publicAppConfig';

export let mapboxgl;
let mapboxLoadPromise;
export function loadMapbox() {
  if (!mapboxLoadPromise) {
    mapboxLoadPromise = import('mapbox-gl').then((module) => {
      mapboxgl = module.default || module;
      mapboxgl.accessToken = MAPBOX_TOKEN;
      return mapboxgl;
    }).catch((error) => {
      mapboxLoadPromise = null;
      throw error;
    });
  }
  return mapboxLoadPromise;
}

